/*
 * @Author: Teemo Ding
 * @Date: 2021-09-22 11:09:09
 * @LastEditTime: 2022-06-08 11:39:13
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/WarehouseLocations/DeliveryMethod/config.tsx
 */

import { EnumMode } from '@/src/components/Antd/NumberInput/NumberInput';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Form } from 'antd';
import React from 'react';
import { TableNumberInput } from 'src/components/EditableTable/TableForm/TableForm';
import { getCourierShow } from '../../CourierAccount/tools';
//import Action from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import css from '../../style.module.less';

// 没用到
export const columns = (onDelete, onEdit) => [
  {
    title: 'Delivery Method Name',
    dataIndex: 'name',
    default: true,
    key: 'name',
    minWidth: 224,
    childGenerate: (text, record, index) => {
      return (
        <div className={css.errorTr}>
          <span>{text}</span>
          {record.hasError && (
            <ExclamationCircleFilled className={css.draftNameErr} />
          )}
        </div>
      );
    },
  },
  {
    title: 'Shipping from Warehouse',
    dataIndex: 'warehouseLocations',
    default: true,
    key: 'warehouseLocations',
    minWidth: 224,
    childGenerate: (text, record, index) => {
      return text.map((item) => item.locationName).join(' , ');
    },
  },
  {
    title: 'Shipping Zone',
    dataIndex: 'shippingZone',
    default: true,
    key: 'shippingZone',
    minWidth: 192,
    childGenerate: (text, record, index) => {
      return text.name || '';
    },
  },
  {
    title: 'Logistic Vendor',
    dataIndex: 'courierAccount',
    default: true,
    key: 'courierAccount',
    minWidth: 160,
    childGenerate: (text) => {
      return text ? getCourierShow(text) : '';
    },
  },
  {
    title: 'Delivery Speed',
    dataIndex: 'shippingSpeed',
    default: true,
    key: 'shippingSpeed',
    minWidth: 160,
  },
  {
    title: 'Actions',
    dataIndex: 'name',
    default: true,
    key: 'name',
    minWidth: 128,
    childGenerate: (text, record, index) => (
      <div className={css.action}>
        <span className={css.danger} onClick={() => onDelete(record.uuid)}>
          Delete
        </span>
        <span className={css.primary} onClick={() => onEdit(record.uuid)}>
          Edit
        </span>
      </div>
    ),
  },
];

// 没用到
export const deliveryPricesColumns = (name) => [
  {
    title: 'Currency',
    dataIndex: 'currency',
    default: true,
    key: 'currency',
    minWidth: 480,
    childGenerate: (text, record, index) => text,
  },
  {
    title: (
      <div>
        <EditIcon />
        <span>Delivery Price</span>
      </div>
    ),
    dataIndex: 'price',
    default: true,
    key: 'price',
    minWidth: 480,
    childGenerate: (text, record, index) => (
      <Form.Item className={css.tableNumberInput} name={[name, index, 'price']}>
        <TableNumberInput
          mode={EnumMode.money}
          // error={priceError}
          rightPosition
          value={text}
          // max={record.maxAmount}
          valueSuffix={` ${record.currency}`}
          suffix={record.currency}
        />
      </Form.Item>
    ),
  },
  {
    title: '',
    dataIndex: 'none',
    default: true,
    key: 'none',
    minWidth: 128,
  },
];

// 没用到
export const additionalDeliveryPriceColumns = [
  {
    title: 'Currency',
    dataIndex: 'currency',
    default: true,
    key: 'currency',
    minWidth: 480,
    childGenerate: (text, record, index) => text,
  },
  {
    title: (
      <div>
        <EditIcon />
        <span>Delivery Price</span>
      </div>
    ),
    dataIndex: 'price',
    default: true,
    key: 'price',
    minWidth: 480,
    childGenerate: (text, record, index) => (
      <Form.Item
        className={css.tableNumberInput}
        name={['additionalDeliveryPrices', index, 'price']}>
        <TableNumberInput
          mode={EnumMode.money}
          // error={priceError}
          rightPosition
          value={text}
          // max={record.maxAmount}
          valueSuffix={` ${record.currency} / per unit`}
          suffix={`${record.currency} / per unit`}
        />
      </Form.Item>
    ),
  },
  {
    title: '',
    dataIndex: 'none',
    default: true,
    key: 'none',
    minWidth: 128,
  },
];

export const fixAmountColumns = ({ getI18n }) => [
  {
    title: getI18n('general.currency'),
    dataIndex: 'currency',
    default: true,
    key: 'currency',
    minWidth: 480,
    childGenerate: (text, record, index) => text,
  },
  {
    title: (
      <div>
        <EditIcon />
        <span>
          {getI18n('storeLogistics.warehouseLocations.additionalFee')}
        </span>
      </div>
    ),
    dataIndex: 'price',
    default: true,
    key: 'price',
    minWidth: 480,
    childGenerate: (text, record, index) => (
      <Form.Item
        className={css.tableNumberInput}
        name={['FixAmountDeliveryPrices', index, 'price']}>
        <TableNumberInput
          mode={EnumMode.money}
          // error={priceError}
          rightPosition
          value={text}
          // max={record.maxAmount}
          valueSuffix={` ${record.currency}`}
          suffix={`${record.currency}`}
        />
      </Form.Item>
    ),
  },
  {
    title: '',
    dataIndex: 'none',
    default: true,
    key: 'none',
    minWidth: 128,
  },
];
